import { useRecoilValue } from 'recoil';
import { correlationLabelDisplayType } from 'venn-state';
import { CorrelationLabelDisplayType } from '../components/grid/types';
import { useBlockId } from '../contexts/BlockIdContext';

export const useCorrelationLabelDisplay = () => {
  const blockId = useBlockId();
  const labelDisplayType = useRecoilValue(correlationLabelDisplayType(blockId));
  return labelDisplayType ?? CorrelationLabelDisplayType.TRUNCATED;
};

export const useIsCorrelationLabelFull = () => {
  const labelDisplayType = useCorrelationLabelDisplay();
  return labelDisplayType === CorrelationLabelDisplayType.FULL;
};
